import React from 'react';

import styles from './Card.module.scss';

interface CardProps {
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
}
export const Card: React.FC<CardProps> = ({ children, onClick, active }) => (
  <div
    className={`${styles.container} ${active && styles.focused} ${
      onClick && styles.onClick
    }`}
    onClick={onClick && onClick}
  >
    {children}
  </div>
);
